import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { environment } from "src/environments/environment";
import { ROLE } from "../helpers/constants";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthGuard  {

    constructor(private router: Router,private authService: AuthService) { }

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        /* If route page was loaded from browser bfcache then do redirect to logout page to fetch from server */
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) {
            let url = new URL(environment.cloudFrontCLPSignOutUrl);
            if (localStorage.getItem('checkInactivity') === 'true') {
              url.searchParams.set('inactive', 'true');
            } else {
              url.searchParams.set('inactive', 'false');
            }
            window.open(url.toString(), "_self");
          }
        });

        const url: string = state.url;
        if((sessionStorage.getItem('isSessionActive') != null || sessionStorage.getItem('isSessionActive') != undefined )){
            if(localStorage.getItem('clpSession')){
            const idToken = this.authService.getCognitoAccessTokenFromStorage();
            const decodedValue = this.authService.decode(idToken);
            const group = decodedValue ? decodedValue['cognito:groups'][0] : '';
                if (url === "/activecase") {
                    if ((group == ROLE.SNN_HIL_MANAGER) || (group == ROLE.SNN_HIL_REVIEWER)) {
                        return true;
                    }else {
                        this.redirectHomepage();
                        return false;
                    }
                }  else if(url === "/casehistory" || url === "/settings"){
                    if (group == ROLE.SNN_HIL_MANAGER) {
                        return true;
                    } else {
                        this.redirectHomepage();
                        return false;
                    }
                } else if(url === "/mycases") {
                    if (group == ROLE.SNN_HIL_REVIEWER) {
                        return true;
                    } else {
                        this.redirectHomepage();
                        return false;
                    }
                } else {
                    return true;
                }
            }else{
                let cloudfrontCLPURL = environment.cloudFrontCLPSignInUrl;
                cloudfrontCLPURL = cloudfrontCLPURL.replace(/signin/g, 'application');
                window.location.href = cloudfrontCLPURL;
                return false;
            }
        } else {
           this.authService.logout();
           return false;
        }
    }
    redirectHomepage(){
        this.router.navigate(['/activecase']);
    }
}
